<template>
    <div layout="column" layout-gt-xs="row" layout-wrap class="md-layout md-alignment-center-center loginCard">
      <div class="md-layout-item md-size-100">
        <span class="md-title">Confirm identity</span>
      </div>
      <div class="md-layout-item md-size-100">
        <br/>
      </div>
      <div class="md-layout-item md-size-100">
        <span>Please enter your current password to make the requested changes</span>
      </div>
      <div class="md-layout-item md-size-100">
          <md-field>
              <label>Password</label>
              <md-input type="password" v-model.trim="password"></md-input>
          </md-field>
      </div>
      <div class="md-layout-item md-size-100">
          <div class="md-layout md-alignment-bottom-center">
              <div class="md-layout-item md-size-30">
                  <md-button class="md-dense md-raised md-accent" @click="$emit('cancel')">Cancel</md-button>
              </div>
              <div class="md-layout-item md-size-40">
              </div>
              <div class="md-layout-item md-size-30">
                  <md-button class="md-dense md-raised md-accent" @click="reAuthenticate(password)">Confirm</md-button>
              </div>
          </div>
      </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { fb } from '../config'

export default {
  name: 'ReAuthenticate',
  data: function () {
    return {
      password: ''
    }
  },
  methods: {
    ...mapActions(['displayError', 'reauthenticateUser']),
    reAuthenticate: function () {
      let user = fb.auth().currentUser
      let credential = fb.auth.EmailAuthProvider.credential(user.email, this.password)
      user.reauthenticateWithCredential(credential).then(() => {
        this.$emit('success')
      }).catch((err) => {
        this.displayError(err.message + ' Try again.')
      })
    }
  }
}
</script>

<style lang="scss">
  .loginCard {
    width: 330px !important;
    box-shadow: none;
  }
  .loginCard svg {
    fill: #ff9800 !important;
  }
  .md-app-container {
    flex: 1 1 auto;
  }
  .md-app-container, .md-app-scroller {
    flex: 1 1 auto;
  }
</style>
